import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const HomeIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M10 9a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Z" />
    <path
      fillRule="evenodd"
      d="M12.65 2.24a1 1 0 0 0-1.3 0l-7 6.03-2.5 2.14a1 1 0 1 0 1.3 1.52L4 11.2V21a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-9.8l.7.6a1 1 0 1 0 1.3-1.5l-2.35-2.02L19 7.7V4a1 1 0 1 0-2 0v1.99l-4.35-3.75ZM18 20V9.5l-5.25-4.51a1 1 0 0 1-.12-.12L12 4.32l-.72.62a1 1 0 0 1-.13.13L6 9.48V20h3v-7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v7h3Zm-5 0v-6h-2v6h2Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default HomeIcon;
